import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { format } from 'date-fns';
import { Tab, Tabs, Card } from 'material-ui';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { downloadContent } from '@utils/fileGenerator';

import * as T from '@modules/trips/_tripsTypes';
import { formatToDecimals } from '@utils/utils';

const styleTab = {
  margin: '5px 0',
  height: '300px',
  overflow: 'auto'
};

const getTime = (time?: string): string | undefined => {
  return time && format(time, 'DD.MM.YYYY HH:mm');
};

export const enhance = compose<T.InnerImportModal, T.OutterImportModal>(
  withHandlers({
    handleDownloadFile: ({ notSavedTrips }) => () => {
      let content = '';
      notSavedTrips.map(o => {
        const time = getTime(o.dateTime) || 'neznámo';
        const vehicle = (o.trip.vehicle && o.trip.vehicle.vehicle.registrationNumber) || 'neznámo';
        const volume = o.trip.refuelingAmount || 'neznámo';
        const price = o.trip.refuelingPrice || 'neznámo';

        content +=
          `Neexistující jízda v čase ${time}, pro vozidlo s SPZ ${vehicle}\n` +
          `Natankováno: ${volume}, Zaplaceno ${price}\n\n`;
      });

      downloadContent('neulozene_jizdy.txt', content);
    }
  })
);

const TripDetailCol: React.SFC<{ label: string; data?: string | number; size?: number }> = ({
  label,
  data = 'Neznámo',
  size = 6
}) => (
  <Col md={6}>
    <Row>
      <Col md={size}>
        <div style={{ fontWeight: 'bold' }}>{label}</div>
      </Col>
      <Col md={12 - size}>
        <div style={{ textAlign: 'right' }}>{data}</div>
      </Col>
    </Row>
  </Col>
);

const TripSavedDetail: React.SFC<T.TripImport> = ({ trip }) => (
  <Card>
    <div style={{ padding: '5px 5px', margin: '10px 0' }}>
      <Row>
        <Col md={12}>
          <Row>
            <TripDetailCol label={'Řidič:'} data={trip.officer && trip.officer.fullName} size={4} />
            <TripDetailCol label={'Služební vozidlo:'} data={trip.vehicle && trip.vehicle.vehicle.registrationNumber} />
          </Row>
        </Col>
        <Col md={12}>
          <Row>
            <TripDetailCol label={'Začátek jízdy:'} data={getTime(trip.startTime)} />
            <TripDetailCol label={'Konec jízdy:'} data={getTime(trip.endTime)} />
          </Row>
        </Col>
        <Col md={12}>
          <Row>
            <TripDetailCol label={'Natankováno:'} data={trip.refuelingAmount} />
            <TripDetailCol label={'Zaplaceno:'} data={formatToDecimals(trip.refuelingPrice)} />
          </Row>
        </Col>
      </Row>
    </div>
  </Card>
);

const TripNotSavedDetail: React.SFC<T.TripImport> = ({ trip, dateTime }) => (
  <Card>
    <div style={{ padding: '5px 5px', margin: '10px 0' }}>
      <Row>
        <Col md={12}>
          <Row>
            <TripDetailCol label={'Neexistující jízda v čase:'} data={getTime(dateTime)} size={7} />
            <TripDetailCol label={'Služební vozidlo:'} data={trip.vehicle && trip.vehicle.vehicle.registrationNumber} />
          </Row>
        </Col>
        <Col md={12}>
          <Row>
            <TripDetailCol label={'Natankováno:'} data={trip.refuelingAmount} />
            <TripDetailCol label={'Zaplaceno:'} data={formatToDecimals(trip.refuelingPrice)} />
          </Row>
        </Col>
      </Row>
    </div>
  </Card>
);

export const View: React.SFC<T.ImportModal> = ({
  savedTrips,
  notSavedTrips,
  onRequestClose: handleRequestClose,
  handleDownloadFile
}) => (
  <div>
    <Tabs className="data">
      <Tab label="Uložené změny">
        <div style={styleTab}>
          <Grid fluid={true}>{savedTrips.map((o, i) => <TripSavedDetail key={i} {...o} />)}</Grid>
        </div>
      </Tab>
      <Tab label="Neuložené změny">
        <div style={styleTab}>
          <Grid fluid={true}>{notSavedTrips.map((o, i) => <TripNotSavedDetail key={i} {...o} />)}</Grid>
        </div>
      </Tab>
    </Tabs>
    <Card>
      <div className="buttons" style={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
        <Button onClick={handleDownloadFile} label={'Stáhnout neuložené změny'} />
        <Button onClick={handleRequestClose} label={'Zavřít'} />
      </div>
    </Card>
  </div>
);

export const TripsImportModal = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsImportModal.tsx